import { EventEmitter2 } from "eventemitter2";
import { fromEvent } from "rxjs";
import { HasEventTargetAddRemove } from "rxjs/internal/observable/fromEvent";

export function documentEvent$<T extends keyof DocumentEventMap>(eventName: T) {
    return fromEvent(document as HasEventTargetAddRemove<DocumentEventMap[T]>, eventName);
}

export function windowEvent$<T extends keyof WindowEventMap>(eventName: T) {
    return fromEvent(window as HasEventTargetAddRemove<WindowEventMap[T]>, eventName);
}

type EventEmitter = {
    on: (eventName: string, handler: any) => void;
    off: (eventName: string, handler: any) => void;
};
export function changedEvent(store: EventEmitter2) {
    return fromEvent<void>(store as EventEmitter, "changed");
}
